import React from 'react';
import { Button, Navbar } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import FarmName from '../layout/header/FarmName';
import { LoadQueueIcon } from '../LoadQueue/LoadQueueCount';
import RangeBoxDate from '../range/RangeBoxDate';
import { Avatar } from '../widgets';
import { useOrganization } from './context/OrganizationContext';

const ThemePreview = () => {
    const { organizationState, themeConfigData } = useOrganization();

    const { organizationName, themeId, uiConfig } = organizationState;
    const { logoUrl, isLogoVisible, isOrganizationVisible, isFarmVisible, organizationFontSize, organizationFontFamily, organizationFontWeight } = uiConfig || {};

    const theme = Array.isArray(themeConfigData) ? themeConfigData.find(e => e.theme_id === themeId) || {} : {};

    const userInfo = useSelector(state => state.auth.userInfo);
    const toggleVisible = isVisible => !isVisible ? 'd-none' : '';
    const setBackgroundColor = (theme) => {
        const themeColor = (((theme || {}).theme_config || {}).primary || {}).main;
        return themeColor ? { backgroundColor: themeColor } : {};
    };

    const headingStyle = () => ({
        fontSize: organizationFontSize,
        fontWeight: organizationFontWeight,
        fontFamily: organizationFontFamily,
    });

    return (
        <div className="theme-pvw-container">
            <div className="main-header">
                <Navbar expand="sm" style={setBackgroundColor(theme)}>
                    <div className="main-header__left">
                        <Button variant="link" className="menu-style">
                            <i className="fa fa-bars"></i>
                        </Button>
                        <Navbar.Brand className={`${toggleVisible(isLogoVisible)}`}>
                            <img src={logoUrl} alt="" />
                        </Navbar.Brand>
                        <h6 style={{ ...headingStyle() }} className={`org-info ${toggleVisible(isOrganizationVisible)}`} >
                            {organizationName}
                        </h6 >
                    </div>
                    {isFarmVisible && <FarmName />}
                    <div className="main-header__right">
                        <div className="nav-bar-action header-menu notification-dropdown" >
                            <LoadQueueIcon show={false} handleShow={null} loadCount={0} />

                            <div className="btn-range-date">
                                <RangeBoxDate />
                            </div>
                        </div>
                        <div className="map-icon-hldr">
                            <i className="icon icon-map"></i>
                        </div>
                        <div >
                            <Avatar
                                className="cursor-pointer"
                                style={{ borderRadius: '50%', marginRight: '11px', height: '42px', width: '42px' }}
                                name={userInfo.loginId}
                                singleLetterAvatar={true} />
                        </div>
                    </div>
                </Navbar>
            </div>
        </div>
    );
};

export default ThemePreview;
